

exports.__esModule = true;
exports.$ChooseCreditOfferRoute = undefined;

require('./directive');

var _squid = require('squid');

var $ChooseCreditOfferRoute = exports.$ChooseCreditOfferRoute = _squid.$ComponentRoute.extend('$ChooseCreditOfferRoute', {

    path: 'chooseCreditOffer',
    directive: 'xo-choose-credit-offer',
    titleContent: 'chooseCreditOffer.choose',
    trackingData: {
        fptiState: 'choose_credit_offer',
        buzname: {
            'fullpage': {
                'pagename': '%::choose_credit_offer',
                'pagename2': '%::choose_credit_offer:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    auth: false,
    children: []
});

angular.value("$ChooseCreditOfferRoute", $ChooseCreditOfferRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ./components/xo-credit-components/src/choose-credit-offer/route.js
// module id = ./components/xo-credit-components/src/choose-credit-offer/route.js
// module chunks = 1